import { useEffect, useRef } from "react";

// Runs `fn` `delay` ms after `deps` last changed. Skips the very first run.
export function useDebouncedEffect(fn, deps, delay = 800) {
  const timer = useRef(null);
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    clearTimeout(timer.current);
    timer.current = setTimeout(fn, delay);
    return () => clearTimeout(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
